'use client';

import { useQueryState } from 'nuqs';
import { useCallback } from 'react';

export const SORT_OPTIONS = [
  { label: 'Featured', value: 'MANUAL' },
  { label: 'Best selling', value: 'BEST_SELLING', isActive: true },
  { label: 'Alphabetically, A-Z', value: 'TITLE_ASCENDING' },
  { label: 'Alphabetically, Z-A', value: 'TITLE_DESCENDING' },
  { label: 'Price, low to high', value: 'PRICE_ASCENDING' },
  { label: 'Price, high to low', value: 'PRICE_DESCENDING' },
  { label: 'Date, old to new', value: 'CREATED_ASCENDING' },
  { label: 'Date, new to old', value: 'CREATED_DESCENDING' },
] as const;

export type SortOption = (typeof SORT_OPTIONS)[number]['value'];

export function useProductListingSortState(
  defaultSort: SortOption = 'BEST_SELLING'
) {
  const [sort, setSort] = useQueryState<SortOption>('sort', {
    defaultValue: defaultSort,
    parse: (value) => {
      return value as SortOption;
    },
    serialize: (value) => value,
  });

  const updateSort = useCallback(
    (newSort: SortOption) => {
      setSort(newSort);
    },
    [setSort]
  );

  return {
    sort,
    updateSort,
    sortOptions: SORT_OPTIONS,
  };
}
